import { render, staticRenderFns } from "./ExitRequest.vue?vue&type=template&id=c2de98f2&scoped=true"
import script from "./ExitRequest.vue?vue&type=script&lang=js"
export * from "./ExitRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2de98f2",
  null
  
)

export default component.exports